import React, { memo, useCallback } from 'react'

import {
  Icon,
  CubeAIOutline,
  ChevronRightDouble,
  ChevronLeftDouble,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useIsUploadedModel from 'Pods/ThreeDStudio/Hooks/useIsUploadedModel'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsModelSettingsOpen } from 'Pods/ThreeDStudio/Store/actions/ui'

function Header() {
  const t = useTranslation()
  const isModelSettingsOpen = useThreeDStudioStore(state => state.ui?.isModelSettingsOpen)
  const isUploadedModel = useIsUploadedModel()

  const handleClick = useCallback(() => {
    setIsModelSettingsOpen(!isModelSettingsOpen)
  }, [isModelSettingsOpen])

  if (isUploadedModel) {
    return null
  }

  return (
    <div
      className={classnames(
        'header__model-settings',
        isModelSettingsOpen && 'header__model-settings--opened'
      )}
      onClick={handleClick}
    >
      {isModelSettingsOpen && (
        <>
          <Icon svgComponent={CubeAIOutline} color="dark" size={iconSizeMedium} notSpaced />
          <span className="header__title">{t('header.modelSettings')}</span>
          <Icon
            svgComponent={ChevronLeftDouble}
            color="dark"
            size={iconSizeMedium}
            notSpaced
            className="header__model-settings-icon"
          />
        </>
      )}
      {!isModelSettingsOpen && <Icon svgComponent={ChevronRightDouble} color="dark" size={iconSizeMedium} notSpaced />}
    </div>
  )
}

export default memo(Header)
